import React from 'react';
import { useLocation } from 'react-router-dom';
import { SimpleTabs } from 'components';
import {
    ServiceType,
    systemItemStyles,
    SystemItemHeader,
    Departments,
    Credential,
    JobTitles,
    PayrollSetup,
    Company,
    Calendars,
    Banks,
} from './core';
import { PlaceOfService } from './core/placeOfService';
import { OrgIntegrations, PermissionList, RolePermission } from 'utils';
import { Management } from '../management';
import { OtherSettings } from './core/otherSettings';

export const SystemItem = ({}) => {
    const classes = systemItemStyles();
    const location = useLocation();
    const info = location?.state;
    const { cSession, cSessionInfo, voiceNoteInfo } = OrgIntegrations();

    const tabsLabels = [
        RolePermission([PermissionList.COMPANY_PROFILE_MANAGE.code]) && {
            label: 'Company Profile',
        },
        RolePermission([PermissionList.ROLES_READ.code]) && {
            label: 'Access',
        },
        RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && {
            label: 'Service Types',
        },
        RolePermission([PermissionList.SYSTEM_CREDENTIALS?.code]) && {
            label: 'Credentials',
        },
        RolePermission([PermissionList.SYSTEM_DEPARTMENTS?.code]) && {
            label: 'Departments',
        },
        RolePermission([PermissionList.SYSTEM_JOB_TITLES?.code]) && {
            label: 'Job Titles',
        },
        RolePermission([
            PermissionList.SYSTEM_PAYCODE_TYPES?.code,
            PermissionList.SYSTEM_MILEAGE?.code,
            PermissionList.SYSTEM_OVERTIME?.code,
        ]) && {
            label: 'Payroll Setup',
        },
        RolePermission([PermissionList.SYSTEM_PLACE_OF_SERVICE?.code]) && {
            label: 'Place of Service',
        },
        RolePermission([PermissionList.MANAGE_INTEGRATIONS?.code]) && {
            label: 'Integrations',
        },
        RolePermission([PermissionList.BANK_MANAGE?.code]) && {
            label: 'Bank',
        },
        (voiceNoteInfo || cSessionInfo
            ? RolePermission([PermissionList.COMPANY_AI_INTEGRATIONS?.code])
            : RolePermission([PermissionList.COMPANY_PROFILE_MANAGE.code])
        ) && {
            label: 'Other Settings',
        },
    ];

    const tabsContent = [
        RolePermission([PermissionList.COMPANY_PROFILE_MANAGE.code]) && {
            tabComponent: <Company />,
            tab: 'Company Profile',
        },
        RolePermission([PermissionList.ROLES_READ.code]) && {
            tabComponent: <Management />,
            tab: 'Access',
        },
        RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && {
            tabComponent: <ServiceType />,
            tab: 'Service Types',
        },
        RolePermission([PermissionList.SYSTEM_CREDENTIALS?.code]) && {
            tabComponent: <Credential />,
            tab: 'Credentials',
        },
        RolePermission([PermissionList.SYSTEM_DEPARTMENTS?.code]) && {
            tabComponent: <Departments />,
            tab: 'Departments',
        },
        RolePermission([PermissionList.SYSTEM_JOB_TITLES?.code]) && {
            tabComponent: <JobTitles />,
            tab: 'Job Titles',
        },
        RolePermission([
            PermissionList.SYSTEM_PAYCODE_TYPES?.code,
            PermissionList.SYSTEM_MILEAGE?.code,
            PermissionList.SYSTEM_OVERTIME?.code,
        ]) && {
            tabComponent: <PayrollSetup />,
            tab: 'Payroll Setup',
        },
        RolePermission([PermissionList.SYSTEM_PLACE_OF_SERVICE?.code]) && {
            tabComponent: <PlaceOfService />,
            tab: 'Place of Service',
        },
        RolePermission([PermissionList.MANAGE_INTEGRATIONS?.code]) && {
            tabComponent: <Calendars />,
            tab: 'Integrations',
        },
        RolePermission([PermissionList.BANK_MANAGE?.code]) && {
            tabComponent: <Banks />,
            tab: 'Bank',
        },
        (voiceNoteInfo || cSessionInfo
            ? RolePermission([PermissionList.COMPANY_AI_INTEGRATIONS?.code])
            : RolePermission([PermissionList.COMPANY_PROFILE_MANAGE.code])
        ) && {
            tabComponent: <OtherSettings />,
            tab: 'Other Settings',
        },
    ];

    const currentTab = tabsContent && tabsContent?.find((i) => i?.tab);

    return (
        <>
            <div className={classes.systemItemWrapper}>
                <SystemItemHeader />
                <SimpleTabs
                    defaultTab={
                        info?.activeTab === 'Integrations' ? 'Integrations'
                            : info?.state?.activeTab === 'Integrations' ? 'Integrations'
                                : currentTab?.tab || 'Company Profile'
                    }
                    tabsLabels={tabsLabels}
                    tabsContent={tabsContent}
                />
            </div>
        </>
    );
};
